import { render, staticRenderFns } from "./area1.vue?vue&type=template&id=ae296d22&"
import script from "./area1.vue?vue&type=script&lang=js&"
export * from "./area1.vue?vue&type=script&lang=js&"
import style0 from "./area1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports